'use strict';

const Alerts = require('lib/alerts');

var template =
    require('employer/templates/payrollHistory/SendPayslipsModal.ejs');
var ModalForm = require('commons/views/ModalForm');
var loader = require('helpers/loader');
var moment = require('moment');

module.exports = ModalForm.extend({

    events: {
        'click .js-cancel': 'cancel',
        'click .js-send':   'send',
        'click .js-reSend': 'reSend'
    },

    setModel: function(model) {
        this.model = model;
    },

    setCollection: function(collection) {
        this.collection = collection;
    },

    render: function() {
        var list = [];
        var wereSent = [];

        this.collection.each(payslip => {
            const item = {
                id: payslip.id,
                name: payslip.getEmployee().get('fullName'),
                email: payslip.getEmployee().get('email')
            };
            if (payslip.get('payslipSent')) {
                item.sentTime =
                    moment(payslip.get('payslipSent')).format('DD-MMM-YYYY');
                wereSent.push(item);
            }
            list.push(item);
        });

        const $tpl = template({
            payslips: this.collection,
            payroll: this.model,
            wereSent: wereSent,
            list: list
        });

        this.$el.html($tpl);
        this.$('#send-people').chosen({width: '95%'});
        this.$('.js-reSend, .js-reSend-box').toggle(wereSent.length > 0);
        this.$('.js-send, .js-send-box').toggle(wereSent.length === 0);
        return this;
    },

    reSend: function() {
        this.$('.js-reSend, .js-reSend-box').toggle();
        this.$('.js-send, .js-send-box').toggle();
    },

    send: function(ev) {
        var stopLoader = loader.startFullScreen(this.$(ev.currentTarget));
        var payslips = this.$('.js-people').val();

        return this.model.sendPayslips(payslips).then(() => {
            Alerts.show('success', {
                title: '',
                text: 'The payslips will be sent shortly to the ' +
                    'selected employees with emails',
                callback: () => {
                    // Seriously?? SERIOUSLY??
                    app.mainRouter.navigate('payroll/h', {
                        trigger: true,
                        replace: true
                    });
                    app.mainRouter.navigate('payroll/history', {
                        trigger: true,
                        replace: true
                    });
                }
            });
        }).catch(err => { Alerts.show('criticalError', err); }).finally(() => {
            stopLoader();
            this.hide();
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payrollHistory/SendPayslipsModal.js